import {
  CART_ADD_ITEM,
  CART_ADD_ITEM_REQUEST, CART_CHANGE_STORE_FAIL, CART_CHANGE_STORE_REQUEST, CART_CHANGE_STORE_SUCCESS,
  CART_CREATE_FAIL,
  CART_CREATE_REQUEST,
  CART_CREATE_SUCCESS,
  CART_EMPTY,
  CART_INFO_FAIL,
  CART_INFO_REQUEST,
  CART_INFO_SUCCESS,
  CART_PAY_FAIL,
  CART_PAY_REQUEST,
  CART_PAY_SUCCESS,
  CART_PROMO_FAIL,
  CART_PROMO_REQUEST,
  CART_PROMO_SUCCESS,
  CART_REMOVE_ITEM_FAIL,
  CART_REMOVE_ITEM_REQUEST,
  CART_REMOVE_ITEM_SUCCESS,
  CART_VERIF_FAIL,
  CART_VERIF_REQUEST,
  CART_VERIF_SUCCESS,
  CART_CHANGE_JACKPOT_AMOUNT_MATCH
} from '../constants/cartConstants';
import { Toast } from '../components/Toast';
import { formatPriceWithEuro, getUserEmail } from '../utils/StringUtils';
import { notifyError, notifyWarning } from '../utils/Notify';
import { CART } from '../constants/routes';
import { generateUniqueSentryInviteId } from '../utils/GuestIdManagement/generateId';
import * as Sentry from '@sentry/react';
import setOrderUserId from '../utils/GuestIdManagement/setOrderUserId';
import { isOlderThan30Minutes } from '../utils/date-helper';
import { WsError } from '../constants/wsError';
import {
  posthogOrderCaptureEvent, posthogOrderGroupEvent,
} from '../posthog/orderEvent';
import {
  POSTHOG_CAPTURE_ORDER_ADD_ITEM, POSTHOG_CAPTURE_ORDER_CHANGE_STORE, POSTHOG_CAPTURE_ORDER_CREATED,
  POSTHOG_CAPTURE_ORDER_REMOVE_ITEM, POSTHOG_CAPTURE_ORDER_UPDATED, POSTHOG_CAPTURE_ORDER_VERIFIED,
  POSTHOG_CAPTURE_PAYMENT_COMPLETED,
  POSTHOG_GROUP_ORDER, POSTHOG_ORDER_CREATED_STATUS, POSTHOG_ORDER_VERIFIED_STATUS,
} from '../posthog/constants';

export const createCart =
  (order, axiosInstance, callback) => async (dispatch, getState) => {
    try {
      if (localStorage.getItem('avis_google')) {
        localStorage.removeItem('avis_google');
      }
      const userData = localStorage.getItem('user');
      const guestId = localStorage.getItem('guestId');
      let user = userData ? JSON.parse(userData) : null;
      order = setOrderUserId(order, user, guestId);
      order.fidCardNumber = user?.fidCard?.[0]?.fidelityInfo?.ficheClient?.numeroCarte || null;
    } catch (error) {
      console.error(
        'Erreur lors de la récupération des données utilisateur:',
        error,
      );
      const fallbackId = generateUniqueSentryInviteId();
      order.userId = fallbackId;
      Sentry.setUser({ id: fallbackId, isGuest: true, isErrorRecovery: true });
    }
    dispatch({ type: CART_CREATE_REQUEST, payload: order });
    if (localStorage.getItem('entryQr')) {
      order.entryQr = localStorage.getItem('entryQr');
    }
    try {
      const { data } = await axiosInstance.post('/orders', order, {
        promoPrice: order.promoprice,
      });
      dispatch({ type: CART_CREATE_SUCCESS, payload: data });
      if (data && data?.order?._id) {
        const orderData = data.order;
        posthogOrderCaptureEvent(orderData, POSTHOG_CAPTURE_ORDER_CREATED);
        posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, POSTHOG_ORDER_CREATED_STATUS, orderData);
      }

      localStorage.setItem(
        'cartItems',
        JSON.stringify(getState().cart.cartItems),
      );
      if (localStorage.getItem('entryQr')) {
        localStorage.removeItem('entryQr');
      }
      Sentry.setTag('orderId', data?._id);
      if (typeof callback === 'function') {
        callback(data);
      }
    } catch (error) {
      dispatch({
                 type: CART_CREATE_FAIL,
                 payload:
                   error.response && error.response.data.message
                     ? error.response.data.message
                     : error.message,
               });
    }
  };

export const addToCart =
  (orderId, product, qty, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: CART_ADD_ITEM_REQUEST });
    try {
      const toPrice = (num) => +parseFloat(num).toFixed(2);
      product.price = toPrice(product.price);
      product.Qty = qty;
      const res = await axiosInstance.put(`orders/${orderId}/add`, product);
      if (!res?.data?._id || isOlderThan30Minutes(res?.data?.createdAt)) {
        return;
      }
      dispatch({
                 type: CART_ADD_ITEM,
                 payload: res.data,
               });
      posthogOrderCaptureEvent(res?.data, POSTHOG_CAPTURE_ORDER_ADD_ITEM);
      posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, 'updated', res?.data);
      localStorage.setItem(
        'cartItems',
        JSON.stringify(getState().cart.cartItems),
      );
    } catch (err) {
      console.log(err);
    }
  };

export const removeFromCart =
  (Code_Barres_Qty, orderId, Products_Qty, axiosInstance) =>
    async (dispatch, getState) => {
      dispatch({ type: CART_REMOVE_ITEM_REQUEST });
      try {
        const res = await axiosInstance.put(
          `orders/${orderId}/delete`,
          Products_Qty,
        );
        if (!res?.data?._id || isOlderThan30Minutes(res?.data?.createdAt)) {
          return;
        }
        posthogOrderCaptureEvent(res?.data, POSTHOG_CAPTURE_ORDER_REMOVE_ITEM);
        posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, 'updated', res?.data);
        dispatch({ type: CART_REMOVE_ITEM_SUCCESS, payload: res.data });
      } catch (err) {
        console.log(err);
        // console.log("product not found in order " + orderId)
        dispatch({ type: CART_REMOVE_ITEM_FAIL });
      }
      localStorage.setItem(
        'cartItems',
        JSON.stringify(getState().cart.cartItems),
      );
    };

export const changeCartStore =
  (orderId, storeId, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: CART_CHANGE_STORE_REQUEST, payload: orderId });

    try {
      const { data } = await axiosInstance.put(`/orders/${orderId}/update-store`, {
        storeId,
      });
      if (!data?._id || isOlderThan30Minutes(data?.createdAt)) {
        return;
      }

      dispatch({ type: CART_CHANGE_STORE_SUCCESS, payload: data });
      posthogOrderCaptureEvent(data, POSTHOG_CAPTURE_ORDER_CHANGE_STORE);
      posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, 'store_updated', data);
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: CART_CHANGE_STORE_FAIL, payload: message });
    }
    localStorage.setItem(
      'cartItems',
      JSON.stringify(getState().cart.cartItems),
    );

  };

export const getCartInfo =
  (orderId, axiosInstance) => async (dispatch, getState) => {
    if (!orderId) return;
    dispatch({ type: CART_INFO_REQUEST, payload: orderId });
    try {
      const { data } = await axiosInstance.get(`/apiws/order/${orderId}`);
      if (!data?._id || isOlderThan30Minutes(data?.createdAt)) {
        return;
      }
      dispatch({ type: CART_INFO_SUCCESS, payload: data });
      posthogOrderCaptureEvent(data, POSTHOG_CAPTURE_ORDER_UPDATED);
      posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, 'updated', data);
    } catch (error) {
      const statusCode = error.response?.status;
      if (statusCode === 404 || statusCode === 500) {
        dispatch({ type: CART_EMPTY });
        notifyError('Commande introuvable', WsError.ORDER_NOT_FOUND);
        return;
      }
      const message =
        error.response?.data?.message ?? error.message;
      dispatch({ type: CART_INFO_FAIL, payload: message });
    }
    localStorage.setItem(
      'cartItems',
      JSON.stringify(getState().cart.cartItems),
    );

  };
export const getCartPromo =
  (orderId, user, axiosInstance) => async (dispatch, getState) => {
    dispatch({ type: CART_INFO_REQUEST, payload: orderId });
    try {
      const { data } = await axiosInstance.post(
        `/apiws/order/${orderId}/promo`,
        {
          user: user,
        },
      );
      // if (!data?._id || isOlderThan30Minutes(data?.createdAt)) {
      //   return;
      // }
      if (data?.apiAvailable === false) {
        if (window.location.pathname === '/scan') {
          notifyError(
            'Service indisponible',
            'Nos services sont indisponibles pour le moment. Nous t\'invitons à réessayer plus tard',
          );
          dispatch({ type: CART_INFO_FAIL, payload: '' });
          return { type: 'CART_INFO_FAIL', message: 'fail' };
        } else {
          dispatch({ type: CART_INFO_SUCCESS, payload: data });
          localStorage.setItem(
            'cartItems',
            JSON.stringify(getState().cart.cartItems),
          );
          return { type: 'CART_INFO_SUCCESS', message: 'success' };
        }
      } else {
        console.log('GET CART PROMO SUCCESS');
        dispatch({ type: CART_INFO_SUCCESS, payload: data });
        localStorage.setItem(
          'cartItems',
          JSON.stringify(getState().cart.cartItems),
        );
        return { type: CART_INFO_SUCCESS, message: 'success' };
      }
    } catch (error) {
      console.log(error);
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: CART_INFO_FAIL, payload: message });
      return { type: 'CART_INFO_FAIL', message: 'fail' };
    }
  };

export const getPromo =
  (order, axiosInstance, promoItem, callBack, setActivateLoading) =>
    async (dispatch, getState) => {
      dispatch({ type: CART_PROMO_REQUEST });
      try {
        const promoCode = promoItem.name.replace(/\s/g, '');
        const { data } = await axiosInstance.put(
          `/orders/${order._id}/promo/${promoItem._id}`,
          { order },
        );
        let orderData = data?.order;
        if (!orderData?._id || isOlderThan30Minutes(orderData?.createdAt)) {
          return;
        }
        switch (data.message) {
          case 'Montant minimal non atteint':
            dispatch({ type: CART_PROMO_FAIL });
            if (promoCode.slice(-1) === 'e') {
              notifyWarning(
                'Panier inférieur à 1€',
                `Le panier doit être d'au moins ${parseFloat(data.promo.price) + 1}€ pour appliquer cette promotion.`,
              );
            } else if (promoCode.slice(-1) === '%') {
              const reductionAmount = promoCode
                .replace('promo', '')
                .replace('%', '');
              notifyWarning(
                'Panier inférieur à 1€',
                `Le panier doit être d'au moins ${formatPriceWithEuro(100 / (100 - parseInt(reductionAmount)))} pour appliquer cette promotion.`,
              );
            }
            break;

          case 'Montant maximal du panier 25€':
            dispatch({ type: CART_PROMO_FAIL });
            Toast('error', `Montant maximal du panier 25€`);
            break;

          case 'promo non disponible':
            // localStorage.setItem('validité', data.message)
            //verifier si le Toast existe deja
            dispatch({ type: CART_PROMO_FAIL });
            Toast('error', 'Promotions non disponible ... 😔');

            break;

          case 'promotion non autorisée':
            // localStorage.setItem('validité', data.message)
            //verifier si le Toast existe deja
            dispatch({ type: CART_PROMO_FAIL });
            Toast('error', 'Promotions non disponible dans ce magasin... 😔');

            break;
          case 'promo appliquée':
            dispatch({ type: CART_PROMO_SUCCESS, payload: data.order });
            localStorage.setItem(
              'cartItems',
              JSON.stringify(getState().cart.cartItems),
            );
            Toast('success', 'Promotion appliquée ! 😁');
            callBack(CART);

            break;

          case 'promotion enlevée':
            // localStorage.removeItem('validité')
            dispatch({ type: CART_PROMO_SUCCESS, payload: data.order });
            localStorage.setItem(
              'cartItems',
              JSON.stringify(getState().cart.cartItems),
            );
            if (setActivateLoading) setActivateLoading(false);
            if (localStorage.getItem('promo_index')) {
              localStorage.removeItem('promo_index');
            }
            Toast('info', 'Promotion enlevée');
            break;

          default:
            console.log(data.message);
        }
      } catch (err) {
        dispatch({ type: CART_PROMO_FAIL });
        alert('Erreur serveur');
      }
    };

export const successPaidOrder = (data) => async (dispatch, getState) => {
  dispatch({ type: CART_PAY_SUCCESS, payload: data });
  posthogOrderCaptureEvent(data, POSTHOG_CAPTURE_PAYMENT_COMPLETED);
  posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, 'paid', data?.order);
  localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const changeJackpotAmountMatch = ({ order }) => async (dispatch, getState) => {
  dispatch({ type: CART_CHANGE_JACKPOT_AMOUNT_MATCH, payload: { order } });
  localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const failPaidOrder = (errorMessage) => async (dispatch) => {
  dispatch({ type: CART_PAY_FAIL, payload: errorMessage }); // TODO : but ?
};

export const payOrder =
  (order, user, paymentIntent, paymentMethod, axiosInstance) =>
    async (dispatch, getState) => {
      const email = getUserEmail(user);
      dispatch({ type: CART_PAY_REQUEST, payload: { order, email } });

      try {
        const { data } = await axiosInstance.put(`/orders/${order._id}/pay`, {
          user,
          paymentIntent,
          paymentMethod,
        });
        dispatch({ type: CART_PAY_SUCCESS, payload: data });
        localStorage.setItem(
          'cartItems',
          JSON.stringify(getState().cart.cartItems),
        );
      } catch (error) {
        const message =
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message;
        dispatch({ type: CART_PAY_FAIL, payload: message });
      }
    };

export const verifOrder =
  (orderId, user, axiosInstance, deviceName) => async (dispatch, getState) => {
    dispatch({ type: CART_VERIF_REQUEST, payload: { orderId } });
    try {
      const { data } = await axiosInstance.put(`/orders/${orderId}/verif`, {
        userId: user?._id,
        verifyAutoDeviceName: deviceName || null,
      });
      dispatch({ type: CART_VERIF_SUCCESS, payload: data });
      posthogOrderCaptureEvent(data, POSTHOG_CAPTURE_ORDER_VERIFIED)
      posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, POSTHOG_ORDER_VERIFIED_STATUS, data?.order);
      localStorage.setItem(
        'cartItems',
        JSON.stringify(getState().cart.cartItems),
      );
    } catch (error) {
      console.log(error);
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: CART_VERIF_FAIL, payload: message });
    }
  };
